import { _js } from '@ifixit/localize';
import * as React from 'react';
import styled from 'styled-components';
import { color, fontSize, breakpoint } from '@core-ds/primitives';
import { User } from '@core-ds/icons/24';
import { BreakpointsContext } from 'core-components';

// @ts-expect-error ts-migrate(7005) FIXME: Variable 'Auth' implicitly has an 'any' type.
declare const Auth;
// @ts-expect-error ts-migrate(7005) FIXME: Variable 'Utils' implicitly has an 'any' type.
declare const Utils;

const UserButton = styled.a`
   svg {
      transition: color 0.1s;
   }

   :hover svg {
      color: ${color.white};
   }
`;

const Text = styled.a`
   margin: 0 16px;
   font-weight: normal;
   font-size: ${fontSize.md};
   transition: color 0.1s;

   :hover {
      color: ${color.blue[400]};
   }

   &,
   :visited {
      color: ${color.white};
   }

   :last-child {
      margin-right: 0;
   }
`;

const Container = styled.div`
   position: relative;
   display: flex;
   justify-content: space-between;
   align-items: center;
   padding-left: 8px;

   ${Text} {
      text-decoration: none;
      white-space: nowrap;
   }
`;

const Divider = styled.div`
   flex-shrink: 0;
   width: 1px;
   height: 24px;
   background: ${color.gray[700]};
`;

const logIn = () => {
   Auth.login({
      from: 'navLogin',
      message: _js('Logging in will reload the page.'),
      reload: !Utils.hasUnsavedChanges(),
   });
};

const signUp = () => {
   Auth.login({
      from: 'navSignup',
      message: _js('Registering will reload the page.'),
      reload: true,
      register: true,
   });
};

const AuthIcons = (props: any) => {
   const breakpoints = React.useContext(BreakpointsContext);

   if (breakpoints.isMobileTablet()) {
      return (
         <UserButton href="#" onClick={logIn}>
            <User color={color.gray[400]} focusable="false" />
         </UserButton>
      );
   }

   return (
      <Container>
         <Text href="#" id="navSignup" onClick={signUp}>
            {_js('Join')}
         </Text>
         <Divider />
         <Text href="#" id="navLogin" onClick={logIn}>
            {_js('Log In')}
         </Text>
      </Container>
   );
};

export default AuthIcons;
